/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';
  /**
   * Вид для верхнего фильтра на страницы Шины и Диски.
   */
  app.TiresAndWheelsFilterView = app.BaseFilterView.extend({
    el: '.content-container-tires-and-wheels',
    additionalOptions: [
      'isMobile',
      'fader',
      'collection',
      'isParamsPopupFilters',
      'hasNewLoader',
      'mainWindow',
    ],
    events: {
      'click .js-parent-category, .js-child-category': 'changeCategory',
      'change .js-select, .js-radio': 'changeFilter',
      'mousedown .js-select': 'handlePopupFilterClose',
      'click .tab-filter, .js-checkbox': 'changeFilter',
      'click .js-popup-opener': 'togglePopup',
      'click .auto-filter .close': 'changeFilter',
      'click .but-apply-filter': 'fetchItems',
      'click .js-param-popup-filter': 'handlePopupFilterOpen',
      'click .js-reset-filters': 'handleResetFilters',
    },
    chosenParentCategoryId: null,
    chosenChildCategoryId: null,
    FILTER_BY_CAR_KEY: 'car_modification',
    WHEELS_CATEGORY_ID: 22711,
    /**
     * Ключи фильтров рендерищихся в попапе
     */
    POPUP_PARAM_KEYS: ['trademark'],
    filterData: {},
    paramKeys: [],
    paramPopupOpenerFilterKey: null,
    /**
     * @inheritDoc
     */
    run: function () {
      this.initTemplates();
      this.tiresAndWheelsCategoriesMap = app.helpers.TemplateHelper.getJson('#tires-and-wheels-categories-json');
      if (this.hasNewLoader) {
        this.childViews.loader = new app.LoaderView({
          contentWrapper: this.$el,
          withFade: true,
          mainWindow: this.mainWindow,
        });
      }
      this.initChosenCategories();
      this.initPopups();
      this.initListeners();
    },
    /**
     * Инициализация шаблонов
     */
    initTemplates: function () {
      this.templateIcon = app.helpers.TemplateHelper.getTemplate('#tires-and-wheels-icon-template');
      this.parentCategoriesTemplate = app.helpers.TemplateHelper.getTemplate('#tires-and-wheels-parent-categories-template');
      this.childCategoriesTemplate = app.helpers.TemplateHelper.getTemplate('#tires-and-wheels-child-categories-template');
      this.filtersTemplate = app.helpers.TemplateHelper.getTemplate('#tires-and-wheels-filters-template');
    },
    /**
     * Инициализация попапов
     */
    initPopups: function () {
      this.childViews.paramPopupFilter = new app.ParamPopupFilter({
        el: $('.param-filter-popup'),
        collection: this.collection,
      });
      this.childViews.popupCarFilter = new app.CarPopupFilterView({
        fader: this.fader,
      });
    },
    /**
     * Инициализация слушателей
     */
    initListeners: function () {
      this.listenTo(Backbone, 'tire-wheel-filters', this.setData);
      this.listenTo(this.childViews.popupCarFilter, 'apply-car-filter', this.applyCarFilter);
      this.listenTo(this.childViews.paramPopupFilter, 'toggle-active-filter', this.toggleActivePopupFilter);
    },
    /**
     * Добавляет/убирает класс активному/неактивному фильтру
     * @param {boolean} isActive Состояние
     * @param {string} filterKey Ключ фильтра
     */
    toggleActivePopupFilter: function (isActive, filterKey) {
      var filter = '.js-param-popup-filter[data-filter-key="' + filterKey + '"]';
      this.$(filter).toggleClass('active', isActive);
    },
    /**
     * Инициализация id выбранных категорий.
     */
    initChosenCategories: function () {
      var chosenParentCategory = _.find(this.tiresAndWheelsCategoriesMap['children'], 'selected');
      if (chosenParentCategory) {
        var chosenChildCategory = _.find(chosenParentCategory['children'], 'selected');
      }
      this.chosenParentCategoryId = chosenParentCategory ? chosenParentCategory.id : null;
      this.chosenChildCategoryId = chosenChildCategory ? chosenChildCategory.id : null;
    },
    /**
     * Смена категории родительской/дочерней.
     * @param {Event} e
     */
    changeCategory: function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $target = $(e.currentTarget),
        categoryType = $target.data('categoryType'),
        categoryId = $target.data('categoryId'),
        categorySlugFilterPage = $target.data('categorySlug');
      if (this.$('.js-' + categoryType.toLowerCase() + '-category').hasClass('locked')
        || this.isFetching
        || categoryId === this.collection.categoryId) {
        return;
      }
      this.listenToOnce(Backbone, 'parseFilterData', this['render' + categoryType + 'Categories']);
      this['chosen' + categoryType + 'CategoryId'] = categoryId;
      if (categoryType === 'Parent') {
        this.chosenChildCategoryId = null;
      }
      this.collection.setFilter('null');
      if (categorySlugFilterPage) {
        Backbone.trigger('change-category-id', categorySlugFilterPage, categoryId);
      }
      this.fetchItems(null, categoryId);
    },
    /**
     * Обрабатывает изменение фильтра.
     * @param {Event} e
     */
    changeFilter: function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $target = $(e.currentTarget),
        filterKey = $target.closest('[data-filter-key]').data('filterKey'),
        filterValue = e.type === 'change' ? $target.val() : $target.data('filterId'),
        filterObj = this.collection.getFilter() || {};
      if (!$target.hasClass('locked')) {
        if (Number(filterValue) >= 0) {
          filterValue = Number(filterValue);
        }
        // при изменении фильтра по сезонности удаляем фильтр по шипам.
        if (filterKey === 'json_ott') {
          delete filterObj.json_otr;
        }
        if (filterValue === 'empty') {
          delete filterObj[filterKey];
          if (filterKey === 'car_modification') {
            filterObj = _.pickBy(filterObj, function (value, key) {
              return !_.includes(key, 'specification');
            });
          }
        } else {
          filterObj[filterKey] = [filterValue];
        }
        this.$('.tab-filter, .js-checkbox, .js-select, .js-radio').addClass('locked');
        this.fetchFilters(filterObj);
      }
    },
    /**
     * Устанавливает значения фильтров.
     *
     * @param {Object} filterObj
     * @param {Array} paramKeys
     */
    setData: function (filterObj, paramKeys) {
      if (this.hasNewLoader) {
        this.childViews.loader.remove();
      } else {
        app.preloader.remove();
      }
      this.filterData = filterObj;
      this.paramKeys = paramKeys;
      var carFilter = _.get(this.filterData, 'car_filter');
      if (this.chosenChildCategoryId) {
        if (carFilter) {
          this.childViews.popupCarFilter.setData(carFilter);
        }
        this.renderFilters();
      }
    },
    /**
     * Открывает/закрывает попап.
     */
    togglePopup: function () {
      this.childViews.popupCarFilter.togglePopup();
    },
    /**
     * Рендер родительских категорий.
     */
    renderParentCategories: function () {
      this.$('.photo-section').html(this.templateIcon({
        wheelsBranchUsed: this.chosenParentCategoryId === this.WHEELS_CATEGORY_ID,
      }));
      this.$('.js-parent-categories').html(this.parentCategoriesTemplate({
        categories: this.tiresAndWheelsCategoriesMap['children'],
        chosenParentCategoryId: this.chosenParentCategoryId,
        each: _.each,
      }));
      this.renderChildCategories();
    },

    /**
     * Рендер дочерних категорий.
     */
    renderChildCategories: function () {
      var selectedCategoriesTree = _.find(this.tiresAndWheelsCategoriesMap['children'], {id: this.chosenParentCategoryId});
      this.isFetching = false;
      if (this.hasNewLoader) {
        this.childViews.loader.remove();
      } else {
        app.preloader.remove();
      }
      this.$('.js-children-categories').html(this.childCategoriesTemplate({
        categories: selectedCategoriesTree['children'],
        parentSlug: selectedCategoriesTree.full_name_slug,
        chosenCategoryId: this.chosenChildCategoryId,
        chosenParentCategoryId: this.chosenParentCategoryId,
        each: _.each,
      }));
      if (this.chosenChildCategoryId) {
        this.renderFilters();
      } else {
        this.$('.filters-block').html('');
      }
    },
    /**
     * Рендер фильров.
     */
    renderFilters: function () {
      var carFilterSelected = this.getCarFilterSelected(this.filterData);
      if (carFilterSelected) {
        this.paramKeys = this.paramKeys.filter(function (key) {
          return _.includes(key, 'specification') || _.includes(['json_fost', 'trademark'], key);
        });
      }
      this.$('.filters-block').html(this.filtersTemplate({
        filters: this.filterData,
        paramKeys: this.paramKeys,
        carFilterSelected: carFilterSelected,
        each: _.each,
        groupBy: _.groupBy,
        sortBy: _.sortBy,
        orderBy: _.orderBy,
        sortCustomizer: this.sortCustomizer,
        get: _.get,
        size: _.size,
        includes: _.includes,
        some: _.some,
        find: _.find,
        hasResetButton: this.hasChosenTiresAndWheelsFilter(),
        wheelsBranchUsed: this.chosenParentCategoryId === this.WHEELS_CATEGORY_ID,
        popupParamKeys: this.isParamsPopupFilters ? this.POPUP_PARAM_KEYS : [],
        popupFilterKey: this.childViews.paramPopupFilter.currentFilterKey,
      }));
    },
    /**
     * Проверяет выбранные фильтры на наличие фильтров из блока "шины и диски"
     * @returns {boolean} Если есть выбранный то true
     */
    hasChosenTiresAndWheelsFilter: function () {
      var filterObj = this.collection.getFilter(),
        hasChosen = false;
      if (filterObj) {
        var selectedFilterKeys = Object.keys(filterObj),
          tireAndWheelFilterKeys = Object.keys(this.filterData).concat(this.FILTER_BY_CAR_KEY);
        hasChosen = selectedFilterKeys.some(function (filterKey) {
          return tireAndWheelFilterKeys.indexOf(filterKey) !== -1;
        });
      }
      return hasChosen;
    },
    /**
     * Собирает все выбранные значения car_filter в строку для заголовка.
     * @param {object} data
     * @returns {string}
     */
    getCarFilterSelected: function (data) {
      var result = [];
      if (_.get(data, 'car_filter.selectedQty')) {
        _.each(['car_vendor', 'car_model', 'car_year', 'car_modification'], function (filter) {
          var selected = _.find(_.toArray(data.car_filter.sub_filters[filter].values), 'selected');
          result.push(selected.name);
        });
      }
      return result.join(' ');
    },
    /**
     * Запрашивает фильтры с переданными параметрами.
     * @param {Object} [filterObj]
     */
    fetchFilters: function (filterObj) {
      var params = app.helpers.UrlHelper.getUrlParameters(),
        updatedFilters = filterObj || null;
      params.f = JSON.stringify(updatedFilters);
      if (this.hasNewLoader) {
        this.childViews.loader.render();
      } else {
        app.preloader.render();
      }
      this.trigger('fetchFilters', params);
    },
    /**
     * Запрашивает товары.
     * @param {(Event|null)}         event       Событие клика по кнопке "Применить"
     * @param {(number|null)}        categoryId  Идентификатор категории
     * @param {(Object|undefined)}   filterObj   Объект фильтров
     */
    fetchItems: function (event, categoryId, filterObj) {
      var params = app.helpers.UrlHelper.getUrlParameters(),
        currentFilterObj = filterObj || this.collection.getFilter();
      params.f = JSON.stringify(currentFilterObj);
      if (categoryId) {
        params.category = categoryId;
      }
      if (event
        && this.collection.compareFilterObjects(currentFilterObj, this.prevFilters)) {
        return false;
      }
      this.prevFilters = currentFilterObj;
      if (!this.hasNewLoader) {
        app.preloader.render();
      } else if (!event) {
        this.childViews.loader.render();
      }
      this.trigger('fetchItems', params);
    },
    /**
     * Применяет фильтр по авто с запросом товаров.
     * @param {Object} [filterObj]
     */
    applyCarFilter: function (filterObj) {
      this.collection.setFilter(JSON.stringify(filterObj));
      this.fetchItems();
    },
    /**
     * Кастомная функция для сортировки по дробным значениям.
     * @param {string} value
     * @returns {number|string}
     */
    sortCustomizer: function (value) {
      var replaced = value.name.replace(',', '.');
      return _.toNumber(replaced) ? _.toNumber(replaced) : value.name;
    },
    /**
     * Обработчик сброса фильтров
     */
    handleResetFilters: function () {
      var filterObj = this.collection.getFilter() || {},
        tireAndWheelFilterKeys = Object.keys(this.filterData).concat(this.FILTER_BY_CAR_KEY);
      Object.keys(filterObj).forEach(function (filterKey) {
        if (tireAndWheelFilterKeys.indexOf(filterKey) !== -1) {
          delete filterObj[filterKey];
        }
      });
      this.fetchItems(null, null, filterObj);
    },
    /**
     * Открывает попап c фильтрами
     * @param {jQuery.Event} event событие
     */
    handlePopupFilterOpen: function (event) {
      var $opener = $(event.currentTarget),
        filterKey = $opener.data('filterKey'),
        filterData = this.filterData[filterKey];
      this.childViews.paramPopupFilter.handlePopupOpen($opener, filterData, filterKey);
    },
    /**
     * Скрывает попап с фильтрами
     */
    handlePopupFilterClose: function () {
      this.childViews.paramPopupFilter.handlePopupClose();
    }
  });
})(jQuery);

}.call(window));